import { render, staticRenderFns } from "./PickupList.vue?vue&type=template&id=e5b67064"
import script from "./PickupList.vue?vue&type=script&lang=js"
export * from "./PickupList.vue?vue&type=script&lang=js"
import style0 from "./PickupList.vue?vue&type=style&index=0&id=e5b67064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports